'use client';

import { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

import { Link } from '@/components/Link';
import { useLayout } from '@/context/layout-context';
import { Paths, ZmyleLinks } from '@/utils/paths';

import { Divider } from './Divider';

export type HelpfulLinksProps = ComponentProps<'div'>;

export function HelpfulLinks({ className, ...props }: HelpfulLinksProps) {
  const { content } = useLayout();

  const {
    company,
    zmyle,
    giftcard,
    searchGiftcard,
    cityGiftcard,
    products,
    storeGiftcards,
    benefitGiftcards,
    networkGiftcards,
    support,
    onlineManual,
    contact,
  } = content.footer;

  return (
    <div
      className={twMerge(
        'mb-5 grid grid-cols-1 gap-5 lg:mb-36 lg:grid-cols-4 lg:gap-4',
        className,
      )}
      {...props}
    >
      <div>
        <ul className="flex flex-col gap-y-5 lg:gap-y-2">
          <li className="font-medium">{company}</li>

          <li>
            <Link className="hover:text-zmyle-secondary" href={Paths.ZMYLE}>
              {zmyle}
            </Link>
          </li>
        </ul>
      </div>

      <Divider className="lg:invisible lg:hidden" />

      <div>
        <ul className="flex flex-col gap-y-5 lg:gap-y-2">
          <li className="font-medium">{giftcard}</li>
          <li>
            <Link className="hover:text-zmyle-secondary" href={Paths.SEARCH}>
              {searchGiftcard}
            </Link>
          </li>
          <li>
            <Link
              className="hover:text-zmyle-secondary"
              href={Paths.NETWORK_GIFTCARDS}
            >
              {cityGiftcard}
            </Link>
          </li>
        </ul>
      </div>

      <Divider className="lg:invisible lg:hidden" />

      <div>
        <ul className="flex flex-col gap-y-5 lg:gap-y-2">
          <li className="font-medium">{products}</li>
          <li>
            <Link className="hover:text-zmyle-secondary" href={Paths.STORES}>
              {storeGiftcards}
            </Link>
          </li>
          <li>
            <Link className="hover:text-zmyle-secondary" href={Paths.BENEFITS}>
              {benefitGiftcards}
            </Link>
          </li>
          <li>
            <Link className="hover:text-zmyle-secondary" href={Paths.NETWORKS}>
              {networkGiftcards}
            </Link>
          </li>
        </ul>
      </div>

      <Divider className="lg:invisible lg:hidden" />

      <div>
        <ul className="flex flex-col gap-y-5 lg:gap-y-2">
          <li className="font-medium">{support}</li>
          <li>
            <Link
              className="hover:text-zmyle-secondary"
              href={ZmyleLinks.MANUAL}
              target="_blank"
              isExternal
            >
              {onlineManual}
            </Link>
          </li>
          <li>
            <Link className="hover:text-zmyle-secondary" href={Paths.CONTACT}>
              {contact}
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
}
